/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CreditAlertConfigsService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get the credit alert configuration for the current company
   * @returns any Credit alert config retrieved successfully
   * @throws ApiError
   */
  public getApiServiceorganizationsProcessesCreditAlertConfigs(): CancelablePromise<{
    /**
     * Credit alert config
     */
    data?: Record<string, any>;
  }> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/serviceorganizations/processes/creditAlertConfigs',
      errors: {
        500: `Internal server error`,
      },
    });
  }

  /**
   * Create or update the credit alert configuration for the current company
   * @param requestBody
   * @returns any Credit alert config updated successfully
   * @throws ApiError
   */
  public putApiServiceorganizationsProcessesCreditAlertConfigs(
    requestBody?: {
      /**
       * List of credit thresholds that trigger notifications
       */
      thresholds: Array<{
        /**
         * "absolute" = credits remaining, "percentage" = percent consumed
         */
        type: 'absolute' | 'percentage';
        /**
         * Threshold value
         */
        value: number;
      }>;
      /**
       * Per-notification-type email lists
       */
      notifyEmailsByType?: {
        balanceThreshold?: Array<string>;
        creditsPurchased?: Array<string>;
      };
      /**
       * Whether alert notifications are enabled
       */
      enabled?: boolean;
    },
  ): CancelablePromise<{
    /**
     * Updated credit alert config
     */
    data?: Record<string, any>;
  }> {
    return this.httpRequest.request({
      method: 'PUT',
      url: '/api/serviceorganizations/processes/creditAlertConfigs',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Bad request - validation error`,
        500: `Internal server error`,
      },
    });
  }

}
